import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e5b1d54"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "svg-icon",
  "aria-hidden": "true"
};
const _hoisted_2 = ["xlink:href"];
import { computed } from 'vue';
export default {
  __name: 'index',
  props: {
    // 添加自定义类名
    className: {
      type: String,
      default: ''
    },
    // iconfont中的名字
    iconName: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const svgClass = computed(() => {
      if (props.className) {
        return `svg-icon ${props.className}`;
      } else {
        return 'svg-icon';
      }
    });
    const iconClassName = computed(() => `#${props.iconName}`);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("use", {
        "xlink:href": `#${__props.iconName}`
      }, null, 8, _hoisted_2)]);
    };
  }
};